import type * as pf from '@amirada/lib-shared'
import type * as tp from '@base/utils/types'
import { useAppIndexStore } from '@base/stores/indexStore'
import { ut_addPathToRoute, ut_returnNewRoute } from '@base/utils/utils'

export function useNavigation() {
  const indexStore = useAppIndexStore()

  /* onMounted(async() => {
    console.log('navi onMounted')
  })

  onBeforeMount(async() => {
    console.log('navi onBeforeMount')
  })

  onUpdated(async() => {
    console.log('navi onUpdated')
  })

  onUnmounted(async() => {
    console.log('navi onUnmounted')
  }) */

  // Get navigation data
  const navigationData = computed((): pf.TPfNode[] | undefined => {
    return indexStore.state.currentNode.nodes
  })

  // Base link path only fetch once
  const linkPathBase = computed((): tp.IParamRouter => {
    const indexStore = useAppIndexStore()
    const queryAddType: tp.IQueryAddType = {
      noPageParams: true,
      noGlobalParams: false,
      noPsx: true,
      noHash: true,
      noCustom: true,
      noTab: true,
    }
    return ut_returnNewRoute(indexStore.getFullPath, {}, '', queryAddType)
  })

  // Add slug to base link path
  function linkPath(slug: string): tp.IParamRouter {
    return ut_addPathToRoute(linkPathBase.value, slug)
  }

  return {
    indexStore,
    navigationData,
    linkPath,
    linkPathBase,
  }
}
